import React, { ReactElement } from 'react';
import Image from '../../image/image.component';
import TextBlock from '../../text-block/text-block.component';
import useStylesMentionItem from './mention-item.styles';
import PersonDefaultImage from '../../../static/images/person-default-image.png';

const MentionItem: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const LABEL_KEY_DEFAULT: string = 'fullName';
  const IMAGE_KEY_DEFAULT: string = 'photo';
  const IMAGE_THUMBNAIL_KEY_DEFAULT: string = 'photoThumbnail';

  const {
    mentionItem,
    defaultImage,
    optionItemLabelKey,
    optionItemImageKey,
    optionItemImageThumbnailKey,
  } = props;

  const { classes } = useStylesMentionItem();

  const labelKey: string = optionItemLabelKey || LABEL_KEY_DEFAULT;
  const imageKey: string = optionItemImageKey || IMAGE_KEY_DEFAULT;
  const imageThumbnailKey: string = optionItemImageThumbnailKey || IMAGE_THUMBNAIL_KEY_DEFAULT;

  return (
    <TextBlock className={classes.mentionItem}>
      <Image
        isDefault
        text={mentionItem[labelKey || LABEL_KEY_DEFAULT]}
        link={mentionItem[imageThumbnailKey] || mentionItem[imageKey] || defaultImage || PersonDefaultImage}
      />
      <TextBlock>
        {mentionItem[labelKey]}
      </TextBlock>
    </TextBlock>
  );
});

export default MentionItem;
